<template>
  <!-- @mouseout="value = false" -->
  <v-hover>
    <template #default="hover_activator_slot">
      <div
        @click="value = true"
        @mouseleave="value?$emit('insert', count):'', value = false"
        @keyup.enter="$emit('insert', count), value = false"
        @keyup.esc="value = false"
        class="activator-insert"
        :style="`
          background-color: ${color};
          height: ${getHeight(hover_activator_slot.hover)};
          width: ${getWidth(hover_activator_slot.hover)};
          border-radius: ${getBorderRadius(hover_activator_slot.hover)};
          ${value?'margin-left: 5px':''}
          `"
      >
        <div v-if="!value" class="activator-iceberg-object" />
        <div
          v-if="value"
          class="activator-insert-element"
        >
          <input
            class="activator-insert-input"
            ref="activator-insert-input"
            type="number"
            v-model="count"
            :min="0"
          >
        </div>
      </div>
    </template>
  </v-hover>
</template>
<script>
export default {
  props: ['color'],
  data: () => ({
    value: false,
    count: 0,
  }),
  watch: {
    value: function(val) {
      if (val) {
        let self = this
        setTimeout(function () {
          self.$refs['activator-insert-input'].select()
        }, 100);
      }
    }
  },
  methods: {
    getBorderRadius(hover) {
      if (this.value) {
        return '3px'
      } else if (hover) {
        return '3px'
      } else {
        return '100%'
      }
    },
    getWidth(hover) {
      if (this.value) {
        return '45px'
      } else if (hover) {
        return '30px'
      } else {
        return '8px'
      }
    },
    getHeight(hover) {
      if (this.value) {
        return '30px'
      } else if (hover) {
        return '20px'
      } else {
        return '8px'
      }
    },
  }
}
</script>
<style>
  .activator-insert {
    position: absolute;
    display: flex;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
    align-items: center;
    justify-content: center;
  }
  .activator-insert-element {
    display: flex;
    color: black;
  }
  .activator-insert-input {
    width: 40px;
    text-align: center;
  }
  .activator-insert-input:focus {
    outline: none;
  }
  /* .activator-insert:hover {
    height: 20px;
    width: 20px;
  } */
</style>
